import React, { Component } from 'react';
import CompanyList from '../companies/CompanyList';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect, Link } from 'react-router-dom';

class Companies extends Component {
  renderNavBar() {
    return (
      <nav>
        <div className="nav-wrapper">
          <div className="col s12">
            <a href="#!" className="breadcrumb">
              First
            </a>
            <a href="#!" className="breadcrumb">
              Second
            </a>
            <a href="#!" className="breadcrumb">
              Third
            </a>
          </div>
        </div>
      </nav>
    );
  }

  renderCompanies() {
    const { companies } = this.props;
    if (companies) {
      return (
        <div className="row">
          <CompanyList companies={companies} />
        </div>
      );
    }
  }
  render() {
    const { auth } = this.props;
    if (!auth.uid) return <Redirect to="/signin" />;
    return (
      <div className="dashboard container">
        {/*this.renderNavBar()*/}
        {this.renderCompanies()}
        <Link className="btn-floating btn-large fixed-action-btn green right" to="newCompany">
          <i className="material-icons">add</i>
        </Link>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    companies: state.firestore.ordered.companies,
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps), firestoreConnect([{ collection: 'companies', orderBy: ['companyName', 'asc'] }]))(Companies);
